import { render, staticRenderFns } from "./resultDetail.vue?vue&type=template&id=5a67ade3&scoped=true"
import script from "./resultDetail.vue?vue&type=script&lang=js"
export * from "./resultDetail.vue?vue&type=script&lang=js"
import style0 from "./resultDetail.vue?vue&type=style&index=0&id=5a67ade3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a67ade3",
  null
  
)

export default component.exports